import React from 'react';
import './Home.css';

class Home extends React.Component {
  render() {
    return (<div className="Home">
            <h2>Home</h2>
      <p >content in progress</p>
            </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js